import {
  Document,
  Font,
  Page,
  StyleSheet,
} from '@react-pdf/renderer';
import PricingInformation from './PricingInformation';
import CoverageSummary from './CoverageSummary';
import VehicleSchedule from './VehiclesSchedule';
import TrailersSchedule from './TrailersSchedule';
import Commodities from './Commodities';
import ELDCamera from './ELDCamera';
import DriverSchedule from './DriverSchedule';

const styles = StyleSheet.create({
  page: {
    padding: 40,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
  },
});

Font.register({
  family: 'Arial',
  fonts: [
    {
      src: '/fonts/arial.TTF',
    },
    {
      src: '/fonts/arialbd.TTF',
      fontWeight: 'bold',
    },
  ],
});

function QuotePDF({ data }) {
  return (
    <Document title="Certificate of Insurance">
      <Page size="A4" style={styles.page}>
        <PricingInformation data={data} />
      </Page>
      <Page size="A4" style={styles.page}>
        <CoverageSummary coverages={data.coverages} />
        <VehicleSchedule vehicles={data?.quote?.vehicles ?? []} />
      </Page>
      <Page size="A4" style={styles.page}>
        <TrailersSchedule trailers={data?.quote?.trailers ?? []} />
        <Commodities
          commoditiesList={data?.quote?.commodities ?? []}
        />
        <ELDCamera operations={data?.quote?.operations ?? []} />
      </Page>
      <Page size="A4" style={styles.page}>
        <DriverSchedule drivers={data?.quote?.drivers} />
      </Page>
    </Document>
  );
}
export default QuotePDF;
